import React from 'react'
import { Box, styled } from '@mui/material'

interface StyledStateIconProps {
  iconcolor: string | undefined
  iconsize: string | undefined
}

const StyledStateIcon = styled(Box)(
  ({ iconcolor, iconsize }: StyledStateIconProps) => {
    return `
    position: relative;
    display:flex;
    justify-content: center;
    align-items: center;
    color: ${iconcolor};
    font-size: ${iconsize ? iconsize : '16px'};
    width: 24px;
    height: 24px;
  `
  }
)

interface TemporaryIconProps {
  iconlabel: string
  iconweight?: string
  iconcolor?: string
  iconsize?: string
}

const TemporaryIcon = ({
  iconlabel,
  iconweight,
  iconcolor,
  iconsize,
  ...props
}: TemporaryIconProps) => {
  return (
    <StyledStateIcon iconcolor={iconcolor} iconsize={iconsize} {...props}>
      <i
        className={`fa-${iconweight ? iconweight : 'regular'} fa-${iconlabel}`}
      />
    </StyledStateIcon>
  )
}

export default TemporaryIcon
